import '@fontsource/audiowide'
import '@fontsource/roboto'
import React from 'react'
import { createRoot } from 'react-dom/client'
import { Provider } from 'react-redux'
import 'semantic-ui-less/semantic.less'
import App from './app/App'
import './index.css'
import * as serviceWorker from './serviceWorker'
import { store } from './store/configureStore'
import { suppressSemanticUIWarnings } from './utils/suppressWarnings'
import * as Sentry from "@sentry/react";

Sentry.init({
  dsn: import.meta.env.VITE_SENTRY_DSN,
  // Setting this option to true will send default PII data to Sentry.
  // For example, automatic IP address collection on events
  sendDefaultPii: true,
  environment: import.meta.env.VITE_SENTRY_ENVIRONMENT || 'local'
});

// Suppress third-party library warnings in development
suppressSemanticUIWarnings()


const container = document.getElementById('root')
if (!container) throw new Error('Root element not found.')

const root = createRoot(container)
const AppContainer: React.FC = () => {
  return (
    <Provider store={store}>
      <App />
    </Provider>
  )
}

root.render(<AppContainer />)

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister()
